<template>
  <div class="card-info">
    <div class="row">
      <div class="col-11 col-md-6 col-lg-4 col-xl-3 mx-auto mt-5">
        <card>
          <div class="text-center mt-3 mb-4">
            <img round width="120" src="@/assets/img/logo-def.png" alt="" />
          </div>
          <h3 class="text-center">{{states[state].title}}</h3>
          <component
                :is="state"
                v-model="state"
           />
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { errorNotify } from "@/plugins/functions";
export default {
  name: "auth",
  components: {
    "login": () => import("@/components/Auth/Login"),
  },
  mounted() {},
  data() {
    return {
        state : 'login',
        states:{
          login : {
             title: 'Вход в систему'
          },
        //  restore:  {
        //      title: 'Восстановление'
        //   },
        //   register: {
        //      title: 'Отправить заявку'
        //   },
        }
    };
  },
  methods: {
 
  },
};
</script>
<style>
</style>
